import { useIncidentsQuery } from "../useIncidentsQuery"

import { eventsQueryKeys } from "./queryKeys"

export function useEventLinestringQuery(
    uuid,
    config = {},
) {
    const url = `events/${uuid}/linestring/`

    return useIncidentsQuery(
        url,
        eventsQueryKeys["linestring"](uuid),
        {},
        config,
    )
}